import {ReactNode} from 'react';

import {ThemeProviderWithoutClassic as ConvUIThemeProviderWithoutClassic} from '@stripe-internal/conversations-ui';
import {InlineDataComponentRegistry} from '@stripe-internal/inline-data';
import {Observability} from '@stripe-internal/conversations-client';

import {AppCloseHandler, AppConfig, AppProfile} from '../../core/types';
import {AppProvider} from '../../core/providers/AppProvider';
import {ConversationsUIFlagsProvider} from './ConversationsUIFlagsProvider';
import {InlineDataProvider} from '../../core/providers/InlineDataProvider';
import {ParentMessageBus} from '../../core/lib/parentMessageBus/ParentMessageBus';

type Props = {
  config: AppConfig;
  profile: AppProfile;
  clientFetch?: typeof fetch;
  parentMessageBus?: ParentMessageBus;
  inlineDataComponents?: InlineDataComponentRegistry;
  children: ReactNode;
  onClose?: AppCloseHandler;
  observability?: Observability;
};

export function StripeAssistantProviders({
  config,
  profile,
  clientFetch,
  parentMessageBus,
  inlineDataComponents,
  onClose,
  observability,
  children,
}: Props) {
  return (
    <ConvUIThemeProviderWithoutClassic>
      <AppProvider
        config={config}
        profile={profile}
        clientFetch={clientFetch}
        parentMessageBus={parentMessageBus}
        onClose={onClose}
        observability={observability}
      >
        <ConversationsUIFlagsProvider>
          <InlineDataProvider components={inlineDataComponents}>
            {children}
          </InlineDataProvider>
        </ConversationsUIFlagsProvider>
      </AppProvider>
    </ConvUIThemeProviderWithoutClassic>
  );
}
